var map = {
	"./brain.svg": [
		"./src/images/brain.svg?9bd2",
		[
			"src_images_brain_svg"
		]
	],
	"./controller.svg": [
		"./src/images/controller.svg?b6de",
		[
			"src_images_controller_svg"
		]
	],
	"./hero-placeholder.svg": [
		"./src/images/hero-placeholder.svg",
		[
			"src_images_hero-placeholder_svg"
		]
	],
	"./hero.png": [
		"./src/images/hero.png",
		[]
	],
	"./logo.svg": [
		"./src/images/logo.svg?6073",
		[
			"src_images_logo_svg"
		]
	],
	"./noise.svg": [
		"./src/images/noise.svg",
		[]
	],
	"./printer.svg": [
		"./src/images/printer.svg?ed2e",
		[
			"src_images_printer_svg"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/images lazy recursive ^\\.\\/.*$ referencedExports: default";
module.exports = webpackAsyncContext;